// extracted by mini-css-extract-plugin
export default {"accordian_heading":"BiFromStyles_accordian_heading__-i7g5","label_margin":"BiFromStyles_label_margin__pXypp","upload_div":"BiFromStyles_upload_div__py-a-"};